import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function EmojiAddIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ...props
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M11 3.07A7 7 0 1 0 16.93 9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M7.5 11.5S8.25 13 10 13s2.5-1.5 2.5-1.5M8 8h0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M12 8h0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M13 5h4m-2-2v4"
  }), /* @__PURE__ */ React__default.createElement("circle", {
    cx: "8",
    cy: "8",
    r: ".25"
  }), /* @__PURE__ */ React__default.createElement("circle", {
    cx: "12",
    cy: "8",
    r: ".25"
  }));
}

export { EmojiAddIcon };
//# sourceMappingURL=EmojiAdd.mjs.map
